import { makeStyles } from '@mui/styles';
import ApolloAccordion from 'apollo-react/components/Accordion';
import AccordionDetails from 'apollo-react/components/AccordionDetails';
import AccordionSummary from 'apollo-react/components/AccordionSummary';
import IconButton from 'apollo-react/components/IconButton';
import Typography from 'apollo-react/components/Typography';
import DeleteIcon from 'apollo-react-icons/Trash';
import React, { useRef } from 'react';

import LazyText from '../../components/LazyText';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getUITA } from '../../utils/commonUtils';
import { FORM_KEYS } from '../constants/form-manager.constants';
import { getAccordionPaddings } from '../utils/form-manager.utils';

const useStyles = makeStyles({
  gridHeader: {
    fontWeight: 600,
    color: 'black',
    fontSize: 14,
  },
  accordionDetails: {
    display: 'block',
    width: '100%',
    paddingBottom: ({ paddingBottom }) => paddingBottom,
    paddingRight: ({ paddingRight }) => paddingRight,
    paddingLeft: ({ paddingLeft }) => paddingLeft,
  },
  actionIcon: {
    position: 'absolute',
    top: 4,
    right: 0,
  },
});

const Accordion = ({
  formKey,
  children,
  showHeader,
  title,
  isCollapsed,
  onChange = () => {},
  onActionClick,
  headerUiTa = '',
  autoScrollUpEnabled = false,
  controlType,
}) => {
  const { isMobileDevice } = useWindowDimensions();
  const isDetailWithoutHeader = !showHeader && formKey !== FORM_KEYS.STEP;
  const elementRef = useRef(null);

  const paddings = getAccordionPaddings({
    isDetailWithoutHeader,
    isMobileDevice,
    controlType,
  });

  const onStateChange = () => {
    onChange();

    if (!autoScrollUpEnabled) {
      return;
    }
    const halfWindowInnerHeight = window.innerHeight / 2;
    const elementBoundingRect = elementRef.current.getBoundingClientRect();
    const topMargin = 100;

    if (halfWindowInnerHeight <= elementBoundingRect.y) {
      setTimeout(() => {
        window.scrollBy({ top: elementBoundingRect.y - topMargin, behavior: 'smooth' });
      }, 300);
    }
  };

  const classes = useStyles({ ...paddings });

  const header = onActionClick ? (
    <AccordionSummary ui-ta={headerUiTa}>
      <Typography className={classes.gridHeader}>
        <LazyText text={title} isAccordion>
          {title}
        </LazyText>
      </Typography>
      <span className={classes.actionIcon} ui-ta={getUITA('FormCtrl', 'DeleteButton')}>
        <IconButton onClick={onActionClick}>
          <DeleteIcon />
        </IconButton>
      </span>
    </AccordionSummary>
  ) : (
    <AccordionSummary ui-ta={headerUiTa}>
      <Typography className={classes.gridHeader}>
        <LazyText text={title} isAccordion>
          {title}
        </LazyText>
      </Typography>
    </AccordionSummary>
  );

  return (
    <ApolloAccordion
      ref={elementRef}
      expanded={!isCollapsed}
      onChange={onStateChange}
      data-collapsed={isCollapsed && showHeader}
    >
      {(showHeader && header) || ''}
      <AccordionDetails
        classes={{
          root: classes.accordionDetails,
        }}
      >
        {children}
      </AccordionDetails>
    </ApolloAccordion>
  );
};

export default Accordion;
